import { Dispatch, SetStateAction } from "react";

import { Typography } from "@mui/material";
import { CreateLessonForm } from "./CreateLessonForm";

export type TListLessonSeparatorProps = {
	order: number;
	addOrder: number | null;
	setAddOrder: Dispatch<SetStateAction<number | null>>;
	isDragging: boolean;
};

export function ListLessonSeparator({
	order,
	addOrder,
	setAddOrder,
	isDragging,
}: TListLessonSeparatorProps) {
	if (isDragging) {
		return <div className="list-lesson-separator-container" />;
	}

	if (addOrder === order) {
		return (
			<>
				<CreateLessonForm
					order={order}
					onClickCancel={() => {
						setAddOrder(null);
					}}
					closeForm={() => {
						setAddOrder(null);
					}}
				/>
				<div className="item-separator-small" />
			</>
		);
	}

	return (
		<div className="list-lesson-separator-container">
			<div
				className="add-button"
				onClick={() => {
					setAddOrder(order);
				}}>
				<div className="add-button-left">
					<Typography className="title-text">+</Typography>
				</div>
				<div className="add-button-right" />
			</div>
		</div>
	);
}
